// @flow
import gql from 'graphql-tag'
import { ADDRESS_FIELDS_FRAGMENT, type Address } from '../address'

export const USER_FIELDS_FRAGMENT = gql`
  fragment UserFields on User {
    id
    admin
    address {
      ...AddressFields
    }
    avatarUrl
    email
    firstName
    lastName
    name
    phone
    phoneWork
    isLicensed
    employer
  }
  ${ADDRESS_FIELDS_FRAGMENT}
`

export type User = {
  id: number,
  admin: boolean,
  address: Address | null,
  avatarUrl: string,
  email: string,
  name: string | null,
  firstName: string | null,
  lastName: string | null,
  phone: string | null,
  phoneWork: string | null,
  employer: string | null,
  isLicensed: boolean | null,
}
